/**
 * Created by Administrador on 20/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('generalDiscountService', generalDiscountService)

    generalDiscountService.$inject = ['$http', 'CONFIG', 'messageService'];

    function generalDiscountService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CARGO_CONTROL + '/' + CONFIG.API + '/generalDiscounts';
        var service = {
            getGeneralDiscounts: getGeneralDiscounts,
            getGeneralDiscountList: getGeneralDiscountList,
            getGeneralDiscount: getGeneralDiscount,
            saveGeneralDiscount: saveGeneralDiscount,
            updateGeneralDiscount: updateGeneralDiscount,
            deleteGeneralDiscount: deleteGeneralDiscount
        }

        return service;

        function getGeneralDiscounts(page, size){
            return $http.get(urlBase + '?page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getGeneralDiscountList(){
            return $http.get(urlBase + '/list')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getGeneralDiscount(id){
            return $http.get(urlBase + "/" + id )
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('generalDiscounts')
                });
        }

        function saveGeneralDiscount(generalDiscounts){
            return $http.post(urlBase, generalDiscounts)
                .then(function(response){
                    messageService.register('generalDiscounts');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('generalDiscounts')
                });
        }

        function updateGeneralDiscount(generalDiscountsId, generalDiscounts){
            return $http.put(urlBase + "/" + generalDiscountsId, generalDiscounts)
                .then(function(response){
                    messageService.registerUpdate('generalDiscounts')
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('generalDiscounts')
                });
        }

        function deleteGeneralDiscount(generalDiscountsId){
            return $http.delete(urlBase + "/" + generalDiscountsId)
                .then(function(response){
                    messageService.registerDelete('generalDiscounts');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('generalDiscounts');
                });
        }
    }
})();
